/* eslint-disable jsx-a11y/anchor-is-valid */
import "../App.css";
import { useState } from "react";
import EstonianFlag from "../flags/ee.svg";
import UKFlag from "../flags/gb.svg";
import RussianFlag from "../flags/ru.svg";
import Swal from "sweetalert2";
import { Button, Input, Radio, Checkbox } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { DatePicker } from "react-rainbow-components";
import dayjs from "dayjs";
import "dayjs/locale/et";
import TextArea from "antd/es/input/TextArea";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = "Europe/Tallinn";

const Estonian = ({
  availableDates,
  csrfTokenState,
  getCallToForm,
  getAvailableDates
}) => {
  dayjs.extend(customParseFormat);
  dayjs.locale("et");

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [birthday, setBirthday] = useState(new Date("01-01-2000"));
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState("eesti");
  const [savedReservation, setSavedReservation] = useState(false);
  const [savedReservationNoDate, setSavedReservationNoDate] = useState(false);
  const [emailVerified, setEmailVerified] = useState(null);
  const [description, setDescription] = useState("");
  const [checkBoxChecked, setCheckboxChecked] = useState(false);
  const [agentType, setAgentType] = useState("regularAgent");
  const [loading, setLoading] = useState(false);

  const options = [
    { label: "eesti", value: "eesti" },
    /* { label: "vene", value: "vene" }, */
    { label: "inglise", value: "inglise" },
    /* { label: "ukraina", value: "ukraina" } */
  ];

  const onChange = ({ target: { value } }) => {
    setSelectedDate(null);
    setSelectedLanguage(value);
  };

  function onDateChange(date) {
    setBirthday(date);
  }

  function selectAvailableDate() {
    const fullName = name + " " + lastName;
    if (selectedDate === "no-date") {
      fetch(`/broneering/broneeri/api/v1/guest/no-select`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-csrf-token": csrfTokenState
        },
        credentials: "include",
        body: `${JSON.stringify({
          name: fullName,
          email,
          phone,
          birthday: dayjs(birthday)?.tz(tz)?.format("DD.MM.YYYY"),
          language: selectedLanguage,
          description
        })}`
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (!data.error) {
            setSavedReservationNoDate(true);
            setName("");
            setLastName("");
            setEmail("");
            setEmailVerified(null);
            setPhone("");
            setBirthday(null);
            setSelectedLanguage(null);
          }
        })
        .catch((err) => {
          console.error("Error selecting available dates", err);
          setLoading(false);
        });
    } else {
      if (
        !selectedDate?.id ||
        !selectedLanguage ||
        !selectedDate?.languages.some(
          (language) => language === selectedLanguage
        )
      )
        return null;
      fetch(`/broneering/broneeri/api/v1/guest/select/${selectedDate?.id}`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "x-csrf-token": csrfTokenState
        },
        credentials: "include",
        body: `${JSON.stringify({
          name: fullName,
          email,
          phone,
          birthday: dayjs(birthday)?.tz(tz)?.format("DD.MM.YYYY"),
          language: selectedLanguage,
          description
        })}`
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (!data.error && data?.message !== "date already reserved") {
            setSavedReservation(true);
            setName("");
            setLastName("");
            setEmail("");
            setEmailVerified(null);
            setPhone("");
            setBirthday(null);
            setSelectedLanguage(null);
          } else {
            if (
              data?.status === "failure" &&
              data?.message === "date already reserved"
            ) {
              setSelectedDate(null);
              Swal.fire({
                title: "Vabandame!",
                icon: "info",
                html: `
                See aeg pole enam saadaval, palun vali teine aeg.
              `,
                showCloseButton: true,
                focusConfirm: false,
                confirmButtonText: `
                OK
              `,
                confirmButtonAriaLabel: "OK"
              });
              return getCallToForm().then((token) => getAvailableDates(token));
            }
          }
        })
        .catch((err) => {
          console.error("Error selecting available dates", err);
          setLoading(false);
        });
    }
  }

  const selectTheDate = (date) => {
    setSelectedDate(date);
  };

  const getPDF = () => {
    fetch(`/broneering/broneeri/api/v1/guest/pdf/est`, {
      method: "GET",
      responseType: "blob",
      headers: {
        "x-csrf-token": csrfTokenState
      },
      credentials: "include"
    })
      .then((res) => res?.arrayBuffer())
      .then((response) => {
        if (response) {
          const file = new Blob([response], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        } else {
          console.error("No response from pdf");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const validateEmail = (email) => {
    if (!email?.length) {
      setEmailVerified(null);
    } else {
      const filterWhiteSpacesEmail = email.replace(/\s+/g, "");
      setEmailVerified(
        String(filterWhiteSpacesEmail)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
      );
      setEmail(filterWhiteSpacesEmail);
    }
  };

  const onCheckboxChange = (e) => {
    setCheckboxChecked(e.target.checked);
  };

  const onChangeAgentType = (e) => {
    setAgentType(e.target.value);
  };

  const getDayOfWeek = (date) => {
    const day = dayjs(date)?.tz(tz).day();
    if (day === 0) return "P";
    if (day === 1) return "E";
    if (day === 2) return "T";
    if (day === 3) return "K";
    if (day === 4) return "N";
    if (day === 5) return "R";
    if (day === 6) return "L";
    return "";
  };

  if (savedReservation)
    return (
      <div className="joinOuterContainer">
        <div className="joinInnerContainer">
          <div style={{ fontSize: "27px", textAlign: "center" }}>
            Registreerusite nõustamisele{" "}
            {dayjs(selectedDate?.startDate)
              ?.tz(tz)
              ?.format("DD.MM.YYYY HH:mm")
              ?.slice(0, -5)}{" "}
            kell{" "}
            {dayjs(selectedDate?.startDate)
              ?.tz(tz)
              ?.format("DD.MM.YYYY HH:mm")
              ?.slice(-5)}
            .
          </div>
          <div
            style={{ textAlign: "center", fontSize: "18px", marginTop: "10px" }}
          >
            Nõustamise kinnitus saadeti teile e-postiga.
          </div>
          <div
            style={{ fontSize: "30px", textAlign: "center", marginTop: "10px" }}
          >
            <CheckCircleFilled style={{ color: "green", marginRight: "7px" }} />
          </div>
        </div>
      </div>
    );
  if (savedReservationNoDate)
    return (
      <div className="joinOuterContainer">
        <div className="joinInnerContainer">
          <div style={{ fontSize: "27px", textAlign: "center" }}>
            Registreerusite nõustamisele.
          </div>
          <div
            style={{ textAlign: "center", fontSize: "18px", marginTop: "10px" }}
          >
            Nõustaja võtab Teiega esimesel võimalusel ühendust.
          </div>
          <div
            style={{ fontSize: "30px", textAlign: "center", marginTop: "10px" }}
          >
            <CheckCircleFilled style={{ color: "green", marginRight: "7px" }} />
          </div>
        </div>
      </div>
    );
  return (
    <div className="App">
      <div id="registration-title-container">
        <div>
          <img
            alt="estonian"
            onClick={() => (window.location.href = "/broneering/broneeri/est")}
            style={{
              marginRight: "10px",
              borderRadius: "3px",
              cursor: "pointer"
            }}
            width={30}
            src={EstonianFlag}
          />
          <img
            alt="english"
            onClick={() => (window.location.href = "/broneering/broneeri/eng")}
            style={{
              marginRight: "10px",
              borderRadius: "3px",
              opacity: 0.4,
              cursor: "pointer"
            }}
            width={30}
            src={UKFlag}
          />
          <img
            alt="russian"
            onClick={() => (window.location.href = "/broneering/broneeri/rus")}
            style={{ borderRadius: "3px", opacity: 0.4, cursor: "pointer" }}
            width={30}
            src={RussianFlag}
          />
        </div>
        <h1>Nõustamisele registreerumine</h1>

        <p>
          Vaimse tervise videonõustajad pakuvad tuge igapäevaeluliste muredega
          toimetulekul. Nõustamine on tasuta. Pöörduda võivad kõik, kellel on
          elus tekkinud pingeid ja raskusi ning tunnevad vajadust kellegagi
          rääkida.
        </p>
        <p>
          Teiega vestleb vaimse tervise spetsialist videosilla vahendusel. Üks
          nõustamine kestab kuni 60 minutit. Juhendame Teid tehnilistes
          üksikasjades, et interneti kaudu kohtumine ladusalt õnnestuks. Tegu ei
          ole teraapia ega psühhiaatrilise abiga ning teenus ei asenda arstiabi.
          Küll aga saab nõustajaga arutada, kuidas end paremini aidata ning kuhu
          professionaalse abi saamiseks pöörduda.
        </p>
        <p>
          Vaimse tervise videonõustamine on mõeldud täiskasvanutele. Lastega
          seonduvas on võimalik pöörduda lasteabi veebilehele: lasteabi.ee või
          lasteabi telefonile: 116 111.
        </p>
        <p>
          Enne registreerimist tutvuge palun teenuse kasutamise tingimustega!
          Teenuse kasutamist loetakse kõikide tingimustega nõustumiseks.
        </p>
        <p>
          Mõni aeg pärast nõustamist saadetakse Teile tagasiside küsimise
          e-kiri. Oleme tänulikud, kui sellele vastate. Saadud tagasisidet
          kasutame teenuse kvaliteedi parendamiseks.
        </p>
        <div
          style={{ color: "#304c6d", cursor: "pointer" }}
          onClick={() => getPDF()}
        >
          <u>Olen tutvunud videonõustamise juhendiga</u>.
        </div>
      </div>

      <Input
        type="hidden"
        name="_token"
        value="icIYXsK0pUGahhlBRpYcZ1BfYs8T4pcX1PQYwlKh"
      />

      <div className="registration-form">
        <div>
          <div className="form-items">
            <label style={{ display: "flex" }}>
              Eesnimi:<div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <Input
                onKeyDown={(event) => {
                  if (event.key === "Enter")
                    document.getElementById("last-name-input")?.focus();
                }}
                className={
                  checkBoxChecked && !name?.length ? "input-no-length" : ""
                }
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>
          <div className="form-items">
            <label style={{ display: "flex" }}>
              Perekonnanimi:
              <div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <Input
                onKeyDown={(event) => {
                  if (event.key === "Enter")
                    document.getElementById("email-input")?.focus();
                }}
                id="last-name-input"
                className={
                  checkBoxChecked && !lastName?.length ? "input-no-length" : ""
                }
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
            </div>
          </div>
          <div className="form-items">
            <label style={{ display: "flex" }}>
              E-post:<div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <Input
                onKeyDown={(event) => {
                  if (event.key === "Enter")
                    document.getElementById("number-input")?.focus();
                }}
                id="email-input"
                className={
                  checkBoxChecked && !email?.length ? "input-no-length" : ""
                }
                value={email}
                onChange={(e) => validateEmail(e.target.value)}
              />
            </div>
            <div style={{ fontWeight: 700, color: "#304c6d", width: "85%" }}>
              <small>
                Palun sisestage e-posti aadress, mida aktiivselt kasutate.
                Saadame sellele aadressile elektroonse kohtumise info.
              </small>
            </div>
          </div>

          <div className="form-items">
            <label style={{ display: "flex" }}>
              Telefon:<div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <Input
                onKeyDown={(event) => {
                  if (
                    event.key === "." ||
                    event.key === "e" ||
                    event.key === " " ||
                    event.code === "Space"
                  )
                    event.preventDefault();
                  if (event.key === "Enter")
                    document.getElementById("input-1")?.click();
                }}
                id="number-input"
                onWheel={(e) => e.target.blur()}
                className={
                  checkBoxChecked && !phone?.length ? "input-no-length" : ""
                }
                type="number"
                value={phone}
                onChange={(e) =>
                  setPhone(e.target.value?.replace(/[^\d]/g, ""))
                }
              />
            </div>
          </div>
          <div className="form-items">
            <label style={{ display: "flex" }}>
              Sünnipäev:<div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <DatePicker
                id="datePicker-1"
                value={birthday}
                onChange={onDateChange}
                maxDate={new Date()}
                locale="et"
                label=""
                formatStyle="medium"
              />
            </div>
          </div>
          <div className="form-items">
            <label>Palun kirjelda paari lausega oma pöördumise põhjus:</label>
            <div style={{ marginTop: "7px", width: "85%" }}>
              <TextArea
                id="reason-input"
                value={description}
                maxLength={500}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div
          className="form-items"
          style={{ display: "flex", marginTop: "7px" }}
        >
          <div style={{ display: "flex" }}>
            Keel:{" "}
            <div
              style={{ color: "red", marginLeft: "5px", marginRight: "10px" }}
            >
              *
            </div>
          </div>
          <Radio.Group
            options={options}
            onChange={onChange}
            value={selectedLanguage}
          />
        </div>
        <div
          className="form-items"
          style={{ display: "flex", marginTop: "20px", marginBottom: "20px" }}
        >
          {/* <Radio.Group onChange={onChangeAgentType} value={agentType}>
            <Radio value="regularAgent">Nõustaja</Radio>
            <Radio value="experienceAgent">Kogemusnõustaja/toimetulek onkoloogilise diagnoosiga {' - '} <a rel="noreferrer" href="https://www.palunabi.ee/et/emotsionaalne-tugi" target="_blank">LISAINFO</a></Radio>
          </Radio.Group> */}
        </div>
        <div style={{ maxHeight: "40%", overflow: "auto" }}>
          <div style={{ height: "100%" }} className="form-items">
            <div
              className={checkBoxChecked && !selectedDate ? "red-text" : ""}
              style={{ marginBottom: "20px", height: "20px", display: "flex" }}
            >
              Vali sobilik aeg:
              <div style={{ color: "red", marginLeft: "5px" }}>*</div>
            </div>
            <div
              style={{
                height: "calc(100% - 20px)",
                overflow: "auto"
              }}
            >
              <div
                id={selectedDate === "no-date" ? "selected" : "default"}
                style={{
                  display: "flex",
                  marginBottom: "10px",
                  cursor: "pointer"
                }}
                onClick={() => selectTheDate("no-date")}
              >
                <div style={{ display: "flex" }}>
                  Ei leidnud sobivat aega{" "}
                  {selectedDate === "no-date" ? (
                    <CheckCircleFilled
                      style={{ color: "#1777ff", marginLeft: "5px" }}
                    />
                  ) : null}
                </div>
              </div>
              {!availableDates?.filter(
                (date) =>
                  date?.languages?.some(
                    (language) => language === selectedLanguage
                  ) &&
                  (date?.agentType === agentType ||
                    (agentType === "regularAgent" && !date?.agentType))
              )?.length ? (
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "20px",
                    color: "black",
                    paddingTop: "10px"
                  }}
                >
                  Aegu pole saadaval
                </div>
              ) : null}
              {availableDates
                ?.filter(
                  (date) =>
                    date?.languages?.some(
                      (language) => language === selectedLanguage
                    ) &&
                    (date?.agentType === agentType ||
                      (agentType === "regularAgent" && !date?.agentType))
                )
                ?.sort((a, b) => new Date(a.startDate) - new Date(b.startDate))
                ?.map((date) => {
                  return (
                    <div
                      id={selectedDate?.id === date.id ? "selected" : "default"}
                      className={date?.client?.name?.length ? "reserved" : ""}
                      style={{
                        display: "flex",
                        marginBottom: "10px",
                        cursor: "pointer"
                      }}
                      onClick={() =>
                        !date?.client?.name?.length ? selectTheDate(date) : null
                      }
                    >
                      <div style={{ display: "flex" }}>
                        {getDayOfWeek(date?.startDate) + " "}{" "}
                        {dayjs(date?.startDate)
                          ?.tz(tz)
                          ?.format("DD.MM.YYYY HH:mm")}{" "}
                        {selectedDate?.id === date.id ? (
                          <CheckCircleFilled
                            style={{ color: "#1777ff", marginLeft: "5px" }}
                          />
                        ) : null}
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <p style={{ display: "flex", justifyContent: "center" }}>
          <div style={{ marginRight: "10px" }}>
            <Checkbox onChange={onCheckboxChange}></Checkbox>
          </div>
          <a
            style={{ color: "#304c6d" }}
            href="https://sotsiaalkindlustusamet.ee/asutus-uudised-ja-kontakt/praktiline-teave/isikuandmete-tootlemine"
            target="_blank"
            rel="noreferrer"
          >
            <u>
              Olen tutvunud ja nõustun SKA isikuandmete töötlemise põhimõtetega
            </u>
          </a>
        </p>
        <div id="reservation-btn">
          <Button
            loading={loading}
            onClick={() => {
              setLoading(true);
              selectAvailableDate();
            }}
            disabled={
              !checkBoxChecked ||
              !phone?.length ||
              !/^\d+$/.test(phone) ||
              !name?.length ||
              !lastName?.length ||
              !emailVerified ||
              dayjs(birthday)?.tz(tz)?.format("DD.MM.YYYY")?.length !== 10 ||
              (!selectedDate?.id?.length && selectedDate !== "no-date") ||
              !selectedLanguage?.length
            }
            size="large"
            type="primary"
          >
            Registreeru
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Estonian;
